import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, mergeMap, filter } from 'rxjs/operators';
import { GenericDeleteDialogComponent } from '@morningstar/shared/ui-kit/generic-delete-dialog';

/**
 * Input stream must be a string value
 * User might have to map to string prior to calling confirm
 * @param fn function that returns the confirmation message for the dialog
 * @param dialog MatDialog instance
 * @param filter If applyFilter, stream does not emit if user reject confirmation
 */
export function confirm(fn: (_: any) => string, dialog: MatDialog, applyFilter = false) {
  return (o$: Observable<any>): Observable<boolean> => {
    return o$.pipe(
      map(_ => fn(_)),
      map(message => (dialog.open<GenericDeleteDialogComponent, any, boolean>(GenericDeleteDialogComponent, {
        data: {
          message
        }
      }) as MatDialogRef<GenericDeleteDialogComponent, boolean>)
        .afterClosed()),
      mergeMap(confirmed => confirmed),
      filter(confirmed => !applyFilter || (confirmed && applyFilter))
    );
  }
}